import { createAsyncThunk } from '@reduxjs/toolkit';
const base = process.env.REACT_APP_API_URL + '/departments';
async function request(path, options, { signal, rejectWithValue }) {
  try {
    const response = await fetch(base + path, { ...options, signal, headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem('token') } });
    const data = await response.json();
    return response.ok ? data : rejectWithValue(data.error || data.message || 'Unable to complete the request.');
  } catch (error) { return rejectWithValue(error.message || 'Unable to connect.'); }
}
export const fetchDepartments = createAsyncThunk('departments/list', (_, api) => request('', { method: 'GET' }, api));
export const saveDepartment = createAsyncThunk('departments/save', ({ id, data }, api) => request(id ? '/' + encodeURIComponent(id) : '', { method: id ? 'PUT' : 'POST', body: JSON.stringify(data) }, api));
